import React, { Component } from 'react'
import { getUser } from '../../actions/session'
import { Notifications } from '../common/notification';
import { Account_Update } from '../../config/rest_endpoints'
import Switch from "react-switch";
import axios from 'axios'
import Select from 'react-select'

const ASR_RANGE_FIELDS = ['localANIASRBlockValue', 'localDNISASRBlockValue'];
const MIN_ASR_VALUE = 1;
const MAX_ASR_VALUE = 100;

class EditAccount extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            accountName: '',
            accountEmail: '',
            rateUpdateEmail: '',
            billingEmail: '',
            ban: '',
            location: '',
            session: '',
            cps: '',
            msg: '',
            accountType: '',
            creditLimit: '',
            switched: true,
            suspend: false,
            selectAccountLCRType:'',
            maxRate: '',
            localANIASRBlockValue:'',
            localDNISASRBlockValue:'',
            minimumProfit: '',
            password: '',
            isEye: true,
            limitSwitch:false,
            selectAccountStatus: '',
            mediaBlock: false,
            optionAccountLCRType:[
                { value: 'system', label: 'True-LCR' },
                { value: 'system-callhold', label: 'LCR Considering Carrier Holdtime' }
            ],
            optionAccountStatus: [
                { value: 'Credit Hold', label: 'Credit Hold' },
                { value: 'Enabled', label: 'Enabled' },
                { value: 'Disabled', label: 'Disabled' }
            ],
            isLoad:false,
            credit: '',
            cName: null,
            inboundCustomerId: 0,
            stirLevel:{ value: '2', label: 'Block Unsigned' },
            optionStir: [
                { value: '1', label: 'No Treatment' },
                { value: '2', label: 'Block Unsigned' },
                { value: '3', label: 'Sign Unsigned Calls with Attestation A' },
                { value: '4', label: 'Sign Unsigned Calls with Attestation B' },
                { value: '5', label: 'Sign Unsigned Calls with Attestation C' },
            ],
            invoiceLevel:{ value: 'Weekly', label: 'Weekly' },
            optionInvoice: [
                { value: 'Weekly', label: 'Weekly' },
                { value: 'Semi-monthly', label: 'Semi-monthly' },
                { value: 'Monthly', label: 'Monthly' },
            ],   

            tnsAsrValue:{ value: 'Off', label: 'Off' },
            optiontnsAsrValue: [
                { value: '-1', label: '-1' },
                { value: '-2', label: '-2' },
                { value: '-3', label: '-3' },
                { value: '-4', label: '-4' },
                { value: 'Off', label: 'Off' },
            ],
        }

        this.handleChange = this.handleChange.bind(this)
        this.onSubmitChange = this.onSubmitChange.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.toggleSwitchSuspend = this.toggleSwitchSuspend.bind(this)
        this.onShowPassword = this.onShowPassword.bind(this)
        this.toggleLimitSwitch = this.toggleLimitSwitch.bind(this)
        this.handleSelectStatus = this.handleSelectStatus.bind(this)
        this.handleSelectAccountLCRType = this.handleSelectAccountLCRType.bind(this)
        this.handleSelectStir = this.handleSelectStir.bind(this)
        this.handleSelecttnsAsrValue = this.handleSelecttnsAsrValue.bind(this)
        this.handleSelectInvoice= this.handleSelectInvoice.bind(this)

    }

    componentWillReceiveProps(newProps) {
        console.log('test111',newProps.previousData)
        const stirValue = this.state.optionStir.find(
            (opt) => opt.label === newProps.previousData.stirShakenLevel
        );
        console.log('stirValue', stirValue)
        this.setState({
            accountName: newProps.previousData.accountName,
            accountEmail: newProps.previousData.accountEmail,
            rateUpdateEmail: newProps.previousData.rateUpdateEmail,
            billingEmail: newProps.previousData.billingEmail,
            ban: newProps.previousData.ban || '',
            location: newProps.previousData.location,
            session: newProps.previousData.sessions,
            cps: newProps.previousData['cps'],
            password: newProps.previousData.password,
            accountType: newProps.previousData.accountType,
            selectAccountLCRType:{ value: newProps.previousData.accountLCRType, label:newProps.previousData.accountLCRType == 'system' ? newProps.previousData.accountLCRType.replace("system", "True-LCR"):"LCR Considering Carrier Holdtime" },
            creditLimit: newProps.previousData.creditLimit,
            suspend:newProps.previousData.suspend,
            switched:newProps.previousData.active,
            limitSwitch:newProps.previousData.disableACTAfterLIM,
            cName: newProps.previousData.cname || '',
            selectAccountStatus:{ value: newProps.previousData.status, label:newProps.previousData.status == 'Credit Hold' ? newProps.previousData.status.replace("Credit Hold", "Credit Hold"):newProps.previousData.status },
            profitMarkup: newProps.previousData.profitMarkup,
            maxRate : newProps.previousData.maxRate,
            stirLevel:stirValue,
            mediaBlock: newProps.previousData.mediaBlock ? newProps.previousData.mediaBlock : false,
            invoiceLevel:{ value: newProps.previousData.invoice, label: newProps.previousData.invoice },
            tnsAsrValue: { 
                value: !newProps.previousData.tnsANIBlockValue ? "Off" : newProps.previousData.tnsANIBlockValue, 
                label: !newProps.previousData.tnsANIBlockValue ? "Off" : newProps.previousData.tnsANIBlockValue
              },
            minimumProfit: newProps.previousData.minimumProfit,
            localANIASRBlockValue: newProps.previousData.localANIASRBlockValue,
            localDNISASRBlockValue: newProps.previousData.localDNISASRBlockValue,

        })
    }

    handleSelectStir(stirLevel) {
        this.setState({ stirLevel})
    }

    handleSelectInvoice(invoiceLevel) {
        this.setState({ invoiceLevel})
    }  

    handleSelecttnsAsrValue(tnsAsrValue) {
        this.setState({ tnsAsrValue})
    }  

    handleSelectStatus(selectAccountStatus) {
        this.setState({ selectAccountStatus });
        console.log(`selectAccountStatus:`, selectAccountStatus);
    };

    handleSelectAccountLCRType(selectAccountLCRType) {
        this.setState({ selectAccountLCRType });
        console.log(`AccountLCRType:`, selectAccountLCRType);
    };


    toggleLimitSwitch() {
        this.setState({ limitSwitch: !this.state.limitSwitch })
    }

    toggleSwitch() {
        this.setState({ switched: !this.state.switched })
    }

    toggleSwitchSuspend() {
        this.setState({ suspend: !this.state.suspend })
    }

    onShowPassword() {
        this.setState({ isEye: !this.state.isEye })
    }

    handleChange(e) {
        if (ASR_RANGE_FIELDS.includes(e.target.name) && e.target.value !== '') {
            const value = Number(e.target.value);
            if (value < MIN_ASR_VALUE || value > MAX_ASR_VALUE) {
                Notifications.notify("ASR values must be between 1 and 100", "Invalid Value", "error")
                return
            }
        }

        this.setState({
            [e.target.name]: e.target.value,
        })
    }

    onSubmitChange() {
        const { previousData, } = this.props
        const { stirLevel } = this.state
        const { invoiceLevel } = this.state
        const { tnsAsrValue } = this.state
        const localANIASR = Number(this.state.localANIASRBlockValue);
        const localDNISASR = Number(this.state.localDNISASRBlockValue);
        if (
            (this.state.localANIASRBlockValue !== '' && (localANIASR < MIN_ASR_VALUE || localANIASR > MAX_ASR_VALUE)) ||
            (this.state.localDNISASRBlockValue !== '' && (localDNISASR < MIN_ASR_VALUE || localDNISASR > MAX_ASR_VALUE))
        ) {
            Notifications.notify("ASR values must be between 1 and 100", "Invalid Value", "error")
            return
        }

        const accountEdit = {
            'accountName': this.state.accountName,
            'accountEmail': this.state.accountEmail,
            'rateUpdateEmail': this.state.rateUpdateEmail,
            'billingEmail': this.state.billingEmail,
            'ban': this.state.ban,
            'location': this.state.location,
            'sessions': parseInt(this.state.session),
            'cps': parseInt(this.state.cps),
            "accountType": this.state.accountType,
            "accountLCRType": this.state.selectAccountLCRType.value,
            "creditLimit": parseFloat(this.state.creditLimit),
            "maxRate": parseFloat(this.state.maxRate),
            "profitMarkup": parseFloat(this.state.profitMarkup),
            'active': this.state.switched,
            'suspend': this.state.suspend,
            'password': this.state.password,
            'disableACTAfterLIM':this.state.limitSwitch,
            'status':this.state.selectAccountStatus.value,
            "stirShakenLevel":stirLevel.value,
            "mediaBlock": this.state.mediaBlock,
            "invoice":invoiceLevel.value,
            'minimumProfit': parseFloat(this.state.minimumProfit),
            'inboundCustomerID': parseInt(this.state.inboundCustomerId),
            'localANIASRBlockValue': this.state.localANIASRBlockValue === '' ? null : parseFloat(this.state.localANIASRBlockValue),
            'localDNISASRBlockValue': this.state.localDNISASRBlockValue === '' ? null : parseFloat(this.state.localDNISASRBlockValue),
            "tnsANIBlockValue":parseInt(tnsAsrValue.value),
            "cname": this.state.cName === '' ? null : this.state.cName,
        };
        console.log('accountEdit', accountEdit)
        this.setState({isLoad:true})
        var headers = { 'Authorization': "Bearer " + this.state.User.token }
        axios.put(`${Account_Update}/${previousData.id}/update`, accountEdit, { headers }).then(res => {
            if (res) {
                console.log('res', res)
                this.setState({
                    msg: res.data.message,
                    isLoad:false
                })
                this.props.close()
                this.props.classListing()
                Notifications.notify(this.state.msg, "Created", "success")
                this.forceUpdate();
            }
            else {
                Notifications.notify("failed Account Created", "Failed", "errors")
            }
        }).catch(err=>{
            this.setState({isLoad:false})
            var msessage = err.response.data.message
            console.log(`msessage`, msessage)
            Notifications.notify(msessage, "Failed", "error")
        })
    }

    render() {
        const { accountName, accountEmail, rateUpdateEmail, billingEmail, ban, location, session, cps, password, profitMarkup, isEye,creditLimit,cName, maxRate , minimumProfit, localANIASRBlockValue, localDNISASRBlockValue} = this.state

        const sectionStyle = {
            fontSize: '13px',
            fontWeight: '600',
            color: '#0F172A',
            letterSpacing: '0.02em',
            paddingBottom: '8px',
            marginBottom: '16px',
            marginTop: '24px',
            borderBottom: '2px solid #E2E8F0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        };

        const labelStyle = {
            fontWeight: '500',
            fontSize: '13px',
            color: '#475569',
            marginBottom: '6px'
        };

        const checkboxWrapperStyle = {
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '10px 14px',
            background: '#F8FAFC',
            borderRadius: '10px',
            border: '1px solid #E2E8F0',
            cursor: 'pointer',
            marginTop: '8px'
        };

        return (
            <div>
                <div style={sectionStyle}>
                    <span style={{width:'6px',height:'6px',borderRadius:'50%',background:'#10B981',display:'inline-block'}}></span>
                    Account Information
                </div>
                <div className='row'>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Account Name</label>
                            <input type="text" className="form-control" name="accountName" value={accountName} onChange={this.handleChange} placeholder="Enter account name" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Account Email</label>
                            <input type="email" className="form-control" name="accountEmail" value={accountEmail} onChange={this.handleChange} placeholder="Enter account email" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Account Status</label>
                            <Select
                                value={this.state.selectAccountStatus}
                                onChange={this.handleSelectStatus}
                                options={this.state.optionAccountStatus}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Address</label>
                            <input type="text" className="form-control" name="location" value={location} onChange={this.handleChange} placeholder="Enter account address" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Cname</label>
                            <input type="text" className="form-control" name="cName" value={cName} onChange={this.handleChange} placeholder="Enter Cname" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Password</label>
                            <div style={{position:'relative'}}>
                                <input type={isEye ? "password" : "text"} className="form-control" name="password" value={password} onChange={this.handleChange} placeholder="Enter password" style={{paddingRight:'40px'}} />
                                <span
                                    onClick={this.onShowPassword}
                                    style={{
                                        position:'absolute',
                                        right:'12px',
                                        top:'50%',
                                        transform:'translateY(-50%)',
                                        cursor:'pointer',
                                        color: isEye ? '#94A3B8' : '#10B981',
                                        fontSize:'16px',
                                        transition:'color 200ms ease'
                                    }}
                                >
                                    <i className="icon-eye"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={sectionStyle}>
                    <span style={{width:'6px',height:'6px',borderRadius:'50%',background:'#3B82F6',display:'inline-block'}}></span>
                    Billing
                </div>
                <div className='row'>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Billing Email (For Invoice)</label>
                            <input type="email" className="form-control" name="billingEmail" value={billingEmail} onChange={this.handleChange} placeholder="Billing Email"/>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Billing Account Number (BAN)</label>
                            <input type="text" className="form-control" name="ban" value={ban} onChange={this.handleChange} placeholder="Enter BAN" />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Rate Update Email</label>
                            <input type="email" className="form-control" name="rateUpdateEmail" value={rateUpdateEmail} onChange={this.handleChange} placeholder="i.e. rates@xyzcompany.com" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Credit Limit</label>
                            <input type="number" className="form-control" name="creditLimit" value={creditLimit} onChange={this.handleChange} placeholder="Enter credit limit" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Invoice Period</label>
                            <Select
                                value={this.state.invoiceLevel}
                                onChange={this.handleSelectInvoice}
                                options={this.state.optionInvoice}
                            />
                        </div>
                    </div>
                </div>

                <div style={sectionStyle}>
                    <span style={{width:'6px',height:'6px',borderRadius:'50%',background:'#8B5CF6',display:'inline-block'}}></span>
                    Settings
                </div>
                <div className='row'>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>CPS</label>
                            <input type="number" className="form-control" name="cps" value={cps} onChange={this.handleChange} placeholder="Enter session" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Session</label>
                            <input type="number" className="form-control" name="session" value={session} onChange={this.handleChange} placeholder="Enter session" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Account LCR Type</label>
                            <Select
                                value={this.state.selectAccountLCRType}
                                onChange={this.handleSelectAccountLCRType}
                                options={this.state.optionAccountLCRType}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Stir Shaken Level</label>
                            <Select
                                value={this.state.stirLevel}
                                onChange={this.handleSelectStir}
                                options={this.state.optionStir}
                            />
                        </div>
                    </div>
                </div>

                <div style={sectionStyle}>
                    <span style={{width:'6px',height:'6px',borderRadius:'50%',background:'#F59E0B',display:'inline-block'}}></span>
                    Monitoring
                </div>
                <div className='row'>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Minimum Profit</label>
                            <input type="number" className="form-control" name="minimumProfit" value={minimumProfit} onChange={this.handleChange} placeholder="Enter Minimum Profit" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Max Rate</label>
                            <input type="number" className="form-control" name="maxRate" value={maxRate} onChange={this.handleChange} placeholder="Enter Max Rate" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Profit Markup</label>
                            <input type="number" className="form-control" name="profitMarkup" value={profitMarkup} onChange={this.handleChange} placeholder="Enter Profit Markup" required />
                        </div>
                    </div>
                </div>

                <div style={sectionStyle}>
                    <span style={{width:'6px',height:'6px',borderRadius:'50%',background:'#EF4444',display:'inline-block'}}></span>
                    ASR Settings
                </div>
                <div className='row'>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Local ASR Value</label>
                            <input type="number" min="1" max="100" className="form-control" name="localANIASRBlockValue" value={localANIASRBlockValue} onChange={this.handleChange} placeholder="Enter Local ASR Value" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Local DNIS ASR Value</label>
                            <input type="number" min="1" max="100" className="form-control" name="localDNISASRBlockValue" value={localDNISASRBlockValue} onChange={this.handleChange} placeholder="Enter Local ASR Value" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>TNS ASR Value</label>
                            <Select
                                value={this.state.tnsAsrValue}
                                onChange={this.handleSelecttnsAsrValue}
                                options={this.state.optiontnsAsrValue}
                            />
                        </div>
                    </div>
                </div>

                <div className="row" style={{marginTop: '8px'}}>
                    <div className="col-md-4">
                        <div style={checkboxWrapperStyle} onClick={this.toggleLimitSwitch}>
                            <input type="checkbox" onChange={this.toggleLimitSwitch} checked={this.state.limitSwitch} style={{width:'16px',height:'16px',accentColor:'#10B981',cursor:'pointer'}} />
                            <div>
                                <div style={{fontSize:'13px',fontWeight:'600',color:'#0F172A'}}>Enforce Credit Limit</div>
                                <div style={{fontSize:'12px',color:'#94A3B8',marginTop:'2px'}}>No calls upon credit limit</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div style={checkboxWrapperStyle} onClick={e => this.setState({ mediaBlock: !this.state.mediaBlock })}>
                            <input
                                type="checkbox"
                                checked={this.state.mediaBlock}
                                onChange={e => this.setState({ mediaBlock: e.target.checked })}
                                style={{width:'16px',height:'16px',accentColor:'#10B981',cursor:'pointer'}}
                            />
                            <div>
                                <div style={{fontSize:'13px',fontWeight:'600',color:'#0F172A'}}>FAS Media Block</div>
                                <div style={{fontSize:'12px',color:'#94A3B8',marginTop:'2px'}}>Activate FAS Carrier Media Filter</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{borderTop:'1px solid #E2E8F0',marginTop:'24px',paddingTop:'20px',display:'flex',justifyContent:'flex-end'}}>
                    <button
                        type="submit"
                        onClick={this.onSubmitChange}
                        style={{
                            background: this.state.isLoad ? '#94A3B8' : 'linear-gradient(135deg, #10B981, #059669)',
                            color: '#FFFFFF',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '13px',
                            fontWeight: '600',
                            cursor: this.state.isLoad ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: this.state.isLoad ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.3)',
                            transition: 'all 200ms ease'
                        }}
                    >
                        Update Account
                        <i className={this.state.isLoad ? "icon-spinner4 spinner" : "icon-pencil5"} style={{fontSize:'14px'}}></i>
                    </button>
                </div>
            </div>
        )
    }
}
export default EditAccount
